import React from 'react'
import { components, type NoticeProps } from 'react-select'

import EmptyState from '../../../EmptyState/EmptyState'

const NoOptionsMessage = <OptionType,>(
  props: NoticeProps<OptionType>,
): React.JSX.Element => {
  return (
    <components.NoOptionsMessage {...props}>
      <EmptyState
        primaryText={
          (props?.children as { props: { children: string } })?.props.children
        }
      />
    </components.NoOptionsMessage>
  )
}

export default NoOptionsMessage
